<template>
    <div>
        <!-- begin:: Header Mobile -->
        <dashboard-header-mobile></dashboard-header-mobile>
        <!-- end:: Header Mobile -->

        <div class="kt-grid kt-grid--hor kt-grid--root">
            <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">

                    <!-- begin:: Header -->
                    <dashboard-header></dashboard-header>
                    <!-- end:: Header -->

                    <div class="kt-container kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-grid--stretch" id="kt_body">
                        
                        <!-- begin:: Aside -->
                        <dashboard-aside v-if="$store.getters['user/is_current_user_fetched']"></dashboard-aside>
                        <!-- end:: Aside -->

                        <div class="kt-holder kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">

                            <!-- begin:: Subheader -->
                            <dashboard-sub-header></dashboard-sub-header>
                            <!-- end:: Subheader -->

                            <div class="kt-content kt-grid__item kt-grid__item--fluid" id="kt_content">                        
                                <go-back-bar v-if="with_go_back_bar"><slot name="action_bar"></slot></go-back-bar>
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                    
                    <!-- begin:: Footer -->
                    <dashboard-footer></dashboard-footer>
                    <!-- end:: Footer -->

                </div>
            </div>
        </div>

        <!-- begin::Scrolltop -->
        <!-- <div id="kt_scrolltop" class="kt-scrolltop">
            <i class="fa fa-arrow-up"></i>
        </div> -->
        <!-- end::Scrolltop -->
    </div>
</template>

<script>
import * as dashboard from './vendors/dashboard'
import goBackBar from './custom/go-back-bar'

export default {
    name: 'mainContent',
    components: {
        'dashboard-header-mobile': dashboard.headerMobile,
        'dashboard-header': dashboard.header,
        'dashboard-aside': dashboard.aside,
        'dashboard-sub-header': dashboard.subHeader,
        'dashboard-footer': dashboard.footer,
        goBackBar,
    },
    props: {
        with_go_back_bar: {
            type: Boolean,
            default: false
        }
    }
}
</script>


<style scoped>

</style>